import React from 'react'
import { l } from '@manychat/manyui'

import { useAppDispatch, useAppSelector } from 'reduxTyped'
import { removePrompt } from 'common/core/actions/uiActions'
import { ConsentPrompt } from 'common/core/components/ConsentPrompt'

export const Prompt = () => {
  const prompts = useAppSelector((state) => state.ui.prompts)
  const dispatch = useAppDispatch()

  if (!prompts || prompts.length === 0) {
    return null
  }

  const [prompt] = prompts

  const handleClose = () => {
    dispatch(removePrompt(prompt.id))
    prompt?.close?.onClick?.()
  }
  const handleConfirm = () => {
    prompt?.confirm?.onClick?.()
    dispatch(removePrompt(prompt.id))
  }

  const close = {
    text: prompt?.close?.text ?? l.translate('No thanks'),
    onClick: handleClose,
  }

  const confirm = {
    text: prompt?.confirm?.text ?? l.translate('Yes, I agree'),
    onClick: handleConfirm,
  }

  return <ConsentPrompt {...prompt} close={close} confirm={confirm} />
}
